const lib = {

  "openCity": [1,4,{}]
  , "allStores": [3,50,{isNeedTest:true,pageNow:1,pageSize:20,isAll:true,deliveryType:[1,2,3,4]}]
  , "menu": [5,1,{isExtId:false,isOptionalRequirement:true,reserveDate:"",sendType:-1,storeId:-1}]
  , "provinceList": ['candao.base.listProvince', { pageNow: 1, pageSize:999}]
  , "allCityList": ['candao.base.getAllCity', { pageNow: 1, pageSize: 999 }]
  , "districtListByCity": ["candao.base.listDistrict", { cityId: -1 }]
  , "nearbyStores": ['candao.storeStandard.getNearStoreList', { coordinate: [], businessType: [1, 2, 3, 4], pageNow: 1, pageSize:999}]
  /* 以上仅为举例 请不要使用,随时可删除 */
  ,"getStoreInfo": ['candao.storeStandard.getStoreById']
  // 根据电话号码获取运营商列表
  ,"getOprList": ['candao.storeStandard.findPlatformByPhone']
  // 根据电话号码获取品牌列表
  ,"getBrandList": ['candao.storeStandard.findBrandByPhone']
  //根据电话查询用户信息
  ,"getUser": ['candao.user.getUser']
  // 获取餐单
  ,"getProductMenu": ['candao.product.getProductMenu', {}]
  ,"getProductMenuByMenuId": ['candao.product.getProductMenuByMenuId', {}]
  // 省份列表
  ,"getListProvince": ['candao.base.listProvince', {}]
  // 城市列表
  ,"getListCity": ['candao.base.listCity', {}]
  // 区域列表
  ,"getListDistrict": ['candao.base.listDistrict', {}]
  // 根据品牌Id列表获取开放省份
  ,"getOpenProvince": ['candao.storeStandard.getOpenProvince', {}]
  // 根据品牌Id列表获取开放城市
  ,"getOpenCity": ['candao.storeStandard.getOpenCity', {}]
  // 根据品牌Id列表获取开放区域
  ,"getOpenDistrict": ['candao.storeStandard.getOpenDistrict', {}]
  //根据复合条件获取门店列表(call center)
  ,"getFindStoresByConds": ['candao.storeStandard.findStoresByConds', {}]
  //批量查询白名单地址列表
  ,"getListWhiteListAddress": ['candao.storeOwn.listWhiteListAddress', {}]
  // 获取腾讯地图key
  ,"getTencentMapKey": ['candao.base.getTencentMapKey', {}]
  //获取门店优惠
  , "getStorePres" : ['candao.preferential.getStorePres']
  //获取能使用的优惠
  , "getCanPreList" : ['candao.preferential.canPreList']
  //获取套餐
  , "getProductGroup": ['candao.product.getGroupData']
  // 搜索餐品
  , "getSearchProduct": ['candao.product.searchMenuProduct']
  //获取用户最后一次下单的餐品
  , "getCcUserLastFinishOrder": ['candao.orderOwn.getCcUserLastFinishOrder']
  // 用户下单
  , "getPostOrder": ['candao.orderOwn.postOrder']
  //优惠卷赠送卡
  , 'getCanUseGiftCardByCode': ['candao.coupon.isCanUseGiftCardByCode']
  //获取订单列表
  , 'getOrderList' : ['candao.orderQuery.getOrderList']
  // 获取订单详情
  , 'getOrderDetail' : ['candao.orderOwn.getOrderDetail']
  //根据订单id获取订单通知
  , 'getOrderWarning' : ['candao.orderOwn.getOrderWarning']
  //获取订单下单渠道、订单状态、订餐业务类型、支付类型、取消或退款状态
  , 'getEnumTypes' : ['candao.orderOwn.getEnumTypes']
  //提醒、催单、提醒
  , 'addOrderWarning': ['candao.orderOwn.addOrderWarning']
  // 获取一级取消原因
  , 'getBigCancelReasons' : ['candao.storeOwn.getBigCancelReasons']
  // 获取二级取消原因
  , 'getSmallCancelReasons' : ['candao.storeOwn.getSmallCancelReasons']
  //ocrm更改订单状态
  , 'ocrmChangeOrderStatus' : ['candao.orderOwn.ocrmChangeOrderStatus']
  // cc订单取消预请求
  , 'addVerifyCancelOrder' : ['candao.orderOwn.addVerifyCancelOrder']
  //获取最近门店(无视配送范围)
  ,"getNearestStoreWithoutRange": ['candao.storeStandard.getNearestStoreWithoutRange', {}]
  // 更新用户嗜好
  ,"updateTaste" : [ 'candao.user.updateTaste' ]
  // 订单能否调整门店
  , "isAdjustOrderStore" : ['candao.orderOwn.isAdjustOrderStore']
  //获取可调整配送的门店列表
  , "findAdjustableStoreList" : ['candao.storeStandard.findAdjustableStoreList']
  // 获取门店列表
  , "findStoreList" : [ 'candao.storeStandard.findStoreList']
  // 调整订单门店
  , "manualAdjustOrderStore" : ['candao.orderOwn.manualAdjustOrderStore']
  //根据品牌Id和门店Id获取CallCenterSetting
  , "getStoreAnnouncement" : ['candao.storeOwn.getCallCenterSettingByStoreId']
  //CC获取门店详情
  , "getStoreInfoForCC" : ['candao.storeStandard.getStoreInfoForCC']
  // cc获取餐品组合
  , "getProductCombination" : ['candao.product.getProductCombination']
  // 获取对应平台的配置
  , "getPlatformByKey": ['candao.authority.getPlatformByKey']
  //根据品牌，电话号码查询门店
  , "findStoreByBrandIdAndPhone": ['candao.storeStandard.findStoreByBrandIdAndPhone']
  // 验证是否可以修改订单
  ,"checkToUpdateOrder" : ['candao.orderOwn.checkToUpdateOrder']
  // 解除锁定
  ,"removeLockToUpdateOrder": ['candao.orderOwn.removeLockToUpdateOrder']
  // 获取品牌信息
  , "getBrandById": ['candao.storeStandard.getBrandById']
  // 修改订单接口
  , "changeOrder": ['candao.orderOwn.changeOrder']
  //  根据餐单ID获取餐单
  , "queryMenuAndProduct": ['candao.product.queryMenuAndProduct']
  // 门店是否在配送范围
  , "getStoreDeliveryRange" : ['candao.storeStandard.getStoreDeliveryRange']
  // 根据品牌Id列表获取商家key
  , "getEnableSecurityKeyByBrandId" : ['candao.storeOwn.getEnableSecurityKeyByBrandId']
  // 获取CC新改单逻辑容错餐品 ->点击立即下单处理
  , "getNewChangeOrderFaultTolerantProduct" : ['candao.orderOwn.getNewChangeOrderFaultTolerantProduct']
};

export default lib;



// WEBPACK FOOTER //
// ./lib/server.js